
import { MarkedRenderer } from 'ngx-markdown';
import { ResourceLibraryService } from 'src/app/services/resource-library/resource-library.service';

export class CustomMarkdownRenderer extends MarkedRenderer {
	constructor(private resourceLibraryService: ResourceLibraryService) {
		super();
	}
	image(href: string | null, title: string | null, text: string): string {
		const resolved = this.resourceLibraryService.resolveUrl(href) || href;
		return super.image(resolved, title, text);
	}
}
